import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AccountRecoveryService } from '../services/account-recovery.service';

/**
 * "Forgot password" — the user enters their email and we send a reset link
 * (email + WhatsApp) via the tenant-scoped recovery endpoint. We always show the
 * same confirmation regardless of whether the account exists (no enumeration).
 */
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
})
export class ForgetPasswordComponent implements OnInit {
  resetForm!: FormGroup;
  isSubmitting = false;
  showSuccess = false;

  constructor(
    private fb: FormBuilder,
    private recovery: AccountRecoveryService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit(): void {
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    this.recovery.forgotPassword(this.resetForm.value.email).subscribe({
      next: () => {
        this.showSuccess = true;
        this.resetForm.reset();
      },
      error: () => {
        // Still show success to avoid leaking whether the account exists.
        this.showSuccess = true;
      },
      complete: () => (this.isSubmitting = false),
    });
  }
}
